// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
		removePriceDecimal: true
	}
};

(function () {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function () {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
    /* start-boost-custom */
    /* #boost-99879: Customize Product's title */
	InstantSearchResultItemProduct.prototype.customizeProductTitle = function() {
		var variant = this.data.variants[0];
      
        var color = variant.merged_options.reduce(function(curr, val) { 
          return val.indexOf('color:') === 0 ? (' ' + val.split('color:')[1]) : curr; }, ''
		);
            
      	return this.title + color;
	}
    /* end-boost-custom */

     InstantSearchApi.beforeCall = function(eventType, eventInfo) {
      if (Shopify && Globals) {
            Globals.instantSearchQueryParams.currency = Shopify.currency.active;
            Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
            Globals.instantSearchQueryParams.country = Shopify.country;
            Globals.instantSearchQueryParams.return_all_currency_fields = false;
      }
    }

})();